import { Component, inject, OnInit } from '@angular/core';
import { SavedQuoteConfigService } from '../../services/saved-quote-config/saved-quote-config.service';

@Component({
    selector: 'lib-saved-quote-list',
    templateUrl: './saved-quote-list.component.html',
    styleUrls: ['./saved-quote-list.component.css'],
    standalone: false
})
export class SavedQuoteListComponent implements OnInit {
  public savedQuoteConfigService = inject(SavedQuoteConfigService);

  ngOnInit() {}
}
